import { render, staticRenderFns } from "./customerInvoiceCreateCreditNote.vue?vue&type=template&id=677f4cca&scoped=true"
import script from "./customerInvoiceCreateCreditNote.vue?vue&type=script&lang=js"
export * from "./customerInvoiceCreateCreditNote.vue?vue&type=script&lang=js"
import style0 from "./customerInvoiceCreateCreditNote.vue?vue&type=style&index=0&id=677f4cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f4cca",
  null
  
)

export default component.exports